import { goBackVar } from "@/utils/variables";
import { InMemoryCache } from "@apollo/client-integration-nextjs";
import { onError } from "@apollo/client/link/error";
import { HttpLink } from "@apollo/client/link/http";

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        goBack: {
          read() {
            return goBackVar();
          },
        },
      },
    },
  },
});
// Error handling link
export const errorLink = onError(({ graphQLErrors, networkError }) => {
  const currentPage = window?.location?.href;
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      console.log(
        `[GraphQL error](page:"${currentPage}"): ${JSON.stringify(error)}`,
      );
      const statusCode = Number(error?.extensions?.code);
      if (401 <= statusCode && statusCode < 500) {
        // Redirect to the 403 page for any 4XX errors
        if (typeof window !== "undefined") {
          window.location.href = "/403";
        }
      }
    });
  }

  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// HTTP link
export const httpLink = new HttpLink({
  uri: process.env.NEXT_PUBLIC_BASE_URL + "/api/graphql",
});
